(function () {
  'use strict';

  var MOQ = 10;
  var QUOTE_AT = 50;
  var STYLE_LABELS = {
    'half-round': 'Half Sleeve + Round Collar',
    'half-polo': 'Half Sleeve + Polo Collar',
    'full-round': 'Full Sleeve + Round Collar',
    'full-polo': 'Full Sleeve + Polo Collar'
  };

  function init() {
    var root = document.querySelector('[data-kjp]');
    var form = root && root.querySelector('[data-kjp-cart-form]');
    if (!root || !form) return;

    var button = form.querySelector('[data-kjp-add-cart]');
    var idInput = form.querySelector('[data-kjp-variant-id]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var noteInput = form.querySelector('[data-kjp-cart-note]');
    var specInput = form.querySelector('[data-kjp-cart-spec]');
    var busy = false;

    function selectedValue(selector, dataName, fallback) {
      var selected = root.querySelector(selector + '.on') || root.querySelector(selector);
      return selected ? selected.dataset[dataName] : fallback;
    }

    function totalQuantity() {
      return Array.prototype.reduce.call(root.querySelectorAll('[data-kjp-size]'), function (sum, input) {
        return sum + Math.max(0, parseInt(input.value, 10) || 0);
      }, 0);
    }

    function hasPaidPrints() {
      return !!root.querySelector('[data-kjp-print].on');
    }

    function variantId() {
      var product = selectedValue('[data-kjp-product]', 'kjpProduct', 'jersey');
      var fabric = selectedValue('[data-kjp-fabric]', 'kjpFabric', 'pp-120');
      var fabricNames = {
        'pp-120': 'Poly Polyester 120 GSM',
        'hc-130': 'Honeycomb Polyester 130 GSM',
        'hcm-150': 'Micro Corsa Honeycomb 150 GSM',
        'dryfit-160': 'Micro P.P Dry-Fit 160 GSM',
        'dotdry-170': 'Micro Dot Knit Dry-Fit 170 GSM'
      };
      var variants = JSON.parse(
        product === 'jersey' ? (root.dataset.variants || '[]') :
        product === 'shorts' ? (root.dataset.variantsShorts || '[]') :
        (root.dataset.variantsPants || '[]')
      );
      var fabricName = fabricNames[fabric];
      if (product !== 'jersey') {
        var accessory = variants.find(function (item) { return item.option1 === fabricName; });
        return accessory ? accessory.id : null;
      }
      var sleeve = selectedValue('[data-kjp-sleeve]', 'kjpSleeve', 'half');
      var collar = selectedValue('[data-kjp-collar]', 'kjpCollar', 'round');
      var style = STYLE_LABELS[sleeve + '-' + (collar === 'round' ? 'round' : 'polo')];
      var jersey = variants.find(function (item) {
        return item.option1 === fabricName && item.option2 === style;
      });
      return jersey ? jersey.id : null;
    }

    function eligibility() {
      var quantity = totalQuantity();
      var id = variantId();
      if (quantity < MOQ) {
        return { allowed: false, quantity: quantity, id: id, label: 'Add ' + (MOQ - quantity) + ' more pcs to order' };
      }
      if (quantity >= QUOTE_AT) {
        return { allowed: false, quantity: quantity, id: id, label: 'Request a quote for 50+ pcs' };
      }
      if (hasPaidPrints()) {
        return { allowed: false, quantity: quantity, id: id, label: 'Request a quote for print add-ons' };
      }
      if (!id) {
        return { allowed: false, quantity: quantity, id: null, label: 'Selected style is unavailable' };
      }
      return { allowed: true, quantity: quantity, id: id, label: 'Add to Cart' };
    }

    function syncButton() {
      if (!button || busy) return;
      var state = eligibility();
      button.disabled = !state.allowed;
      button.textContent = state.allowed ? '\ud83d\uded2 ' + state.label : state.label;
    }

    function showError(message) {
      root.querySelectorAll('[data-kjp-err]').forEach(function (element) {
        element.textContent = message;
      });
    }

    root.addEventListener('input', syncButton);
    root.addEventListener('click', function () { setTimeout(syncButton, 0); });
    setTimeout(syncButton, 0);

    form.addEventListener('submit', function (event) {
      if (event.defaultPrevented || busy) return;
      event.preventDefault();

      var state = eligibility();
      if (!state.allowed) {
        syncButton();
        showError(state.label + '.');
        return;
      }

      var specification = noteInput ? noteInput.value : '';
      idInput.value = state.id;
      quantityInput.value = state.quantity;
      if (specInput) specInput.value = specification;

      var data = new FormData(form);
      data.delete('note');
      busy = true;
      button.disabled = true;
      button.textContent = 'Adding...';
      showError('');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      }).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Could not add this configuration to cart.');
        });
      }).then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: specification })
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('The jersey was added, but its configuration note could not be saved.');
        window.location.assign('/cart');
      }).catch(function (error) {
        busy = false;
        showError(error.message || 'Could not add to cart. Please request a quote.');
        syncButton();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
}());
